import { SiteModelIssue } from './site-model.types';

/** Refus d'un dépôt de modèle, prêt à afficher : un titre et tous les motifs. */
export interface SiteModelRejectionView {
  message: string;
  issues: SiteModelIssue[];
}

/** Libellé lisible d'un code de motif (api-site 8.1.0 `SiteModelIssueCode`). */
export const SITE_MODEL_ISSUE_LABELS: Record<string, string> = {
  NOT_GLB: 'Format',
  NO_GEOREF: 'Géoréférencement',
  UNSUPPORTED_CRS: 'Géoréférencement',
  INVALID_METADATA: 'Métadonnées',
  NO_LEVELS: 'Niveaux',
  TOO_FAR_FROM_SITE: 'Position',
  NO_ROOMS: 'Pièces',
  NO_GATEWAY_TO_CHECK: 'Position',
  FILE_TOO_LARGE: 'Taille',
};

/**
 * Lit l'erreur d'un dépôt de modèle : 422 `SiteModelRejection` (motifs du serveur), 413 (au-delà
 * de 20 Mo). `null` pour toute autre erreur, qui reste une erreur technique à afficher telle quelle.
 */
export function siteModelRejection(error: unknown): SiteModelRejectionView | null {
  const e = error as { status?: number; error?: unknown } | null;
  if (!e || typeof e !== 'object') {
    return null;
  }
  if (e.status === 413) {
    return {
      message: 'Fichier trop volumineux : 20 Mo au plus.',
      issues: [{ code: 'FILE_TOO_LARGE', message: 'Le fichier dépasse 20 Mo.' }],
    };
  }
  const body = e.error as { code?: string; message?: string; issues?: SiteModelIssue[] } | null;
  if (e.status === 422 && body && body.code === 'SITE_MODEL_REJECTED' && Array.isArray(body.issues)) {
    return { message: body.message ?? 'Modèle refusé : le modèle précédent reste en place.', issues: body.issues };
  }
  return null;
}
